<!-- Switch Input -->
@if (name) {
  <div class="w-full"
       [class.field]="formField">
    @if (label) {
      <label
        id="{{ name }}_label"
        class="flex flex-grow-1"
        [class.mb-2]="!formField"
        for="{{ name }}">
        <span class="white-space-wrap overflow-hidden text-overflow-ellipsis">
          {{ label | translate }}
        </span>
      </label>
    }
    <div class="flex flex-column row-gap-2 align-items-center">
      <div class="flex flex-row column-gap-2">
        <p-radioButton name="{{ name }}"
          [ngModel]="false"
          [ngModelOptions]="{standalone: true}"
          [disabled]="true"
        inputId="{{ name }}_bottomLeft"></p-radioButton>
        <p-radioButton name="{{ name }}"
          formControlName="{{ name }}"
          value="bottomCenter"
          inputId="{{ name }}_bottomCenter"
          [disableControl]="disabled"
          [ngClass]="{
            'ng-invalid': control.invalid && control.touched,
            'ng-dirty': control.invalid && control.touched
          }"
        (onClick)="valueChange.emit($event)"></p-radioButton>
        <p-radioButton name="{{ name }}"
          [ngModel]="false"
          [ngModelOptions]="{standalone: true}"
          [disabled]="true"
        inputId="{{ name }}_bottomRight"></p-radioButton>
      </div>
      <div class="flex flex-row column-gap-2">
        <p-radioButton name="{{ name }}"
          formControlName="{{ name }}"
          value="rightCenter"
          inputId="{{ name }}_rightCenter"
          [disableControl]="disabled"
          [ngClass]="{
            'ng-invalid': control.invalid && control.touched,
            'ng-dirty': control.invalid && control.touched
          }"
        (onClick)="valueChange.emit($event)"></p-radioButton>
        <p-radioButton name="{{ name }}"
          formControlName="{{ name }}"
          value="center"
          inputId="{{ name }}_center"
          [disableControl]="disabled"
          [ngClass]="{
            'ng-invalid': control.invalid && control.touched,
            'ng-dirty': control.invalid && control.touched
          }"
        (onClick)="valueChange.emit($event)"></p-radioButton>
        <p-radioButton name="{{ name }}"
          formControlName="{{ name }}"
          value="leftCenter"
          inputId="{{ name }}_leftCenter"
          [disableControl]="disabled"
          [ngClass]="{
            'ng-invalid': control.invalid && control.touched,
            'ng-dirty': control.invalid && control.touched
          }"
        (onClick)="valueChange.emit($event)"></p-radioButton>
      </div>
      <div class="flex flex-row column-gap-2">
        <p-radioButton name="{{ name }}"
          [ngModel]="false"
          [ngModelOptions]="{standalone: true}"
          [disabled]="true"
        inputId="{{ name }}_topLeft"></p-radioButton>
        <p-radioButton name="{{ name }}"
          formControlName="{{ name }}"
          value="topCenter"
          inputId="{{ name }}_topCenter"
          [disableControl]="disabled"
          [ngClass]="{
            'ng-invalid': control.invalid && control.touched,
            'ng-dirty': control.invalid && control.touched
          }"
        (onClick)="valueChange.emit($event)"></p-radioButton>
        <p-radioButton name="{{ name }}"
          [ngModel]="false"
          [ngModelOptions]="{standalone: true}"
          [disabled]="true"
        inputId="{{ name }}_topRight"></p-radioButton>
      </div>
    </div>
    @if (control.invalid && (control.dirty || control.touched)) {
      <br/>
      @for (err of control.errors | keyvalue; track err) {
        <small id="{{ name }}_help"
          class="p-error w-max">
          {{ err.value | translate }}
        </small>
        <br/>
      }
    }
  </div>
}
